import { useEffect } from 'preact/hooks'
import type { WebViewDto } from '@/api/webs'
import { ScheduleXCalendar } from '@/components/calendar/ScheduleXCalendar'
import { useAIChatContextUpdater } from '@/hooks'
import { ChatLocations, ChatEntityTypes, ChatViewModes } from '@/constants/aiChat'

interface Props {
  web: WebViewDto
  clientCompanyId: string
}

export function WebCalendarTab({ web, clientCompanyId }: Props) {
  const { updateContext } = useAIChatContextUpdater()

  useEffect(() => {
    updateContext({
      campaignId: web.CampaignId,
      webId: web.Id,
      location: ChatLocations.WebCalendar,
      entityType: ChatEntityTypes.Web,
      entityId: web.Id,
      viewMode: ChatViewModes.View,
      availableFields: [],
      availableActions: ['CopyToClipboard'],
    })
  }, [web.WorkspaceId, web.CampaignId, web.Id, updateContext])

  return (
    <div className="-m-6">
      <ScheduleXCalendar
        clientCompanyId={clientCompanyId}
        workspaceId={web.WorkspaceId}
        webId={web.Id}
      />
    </div>
  )
}
